module.exports = __webpack_public_path__ + "img/two-lines-dark.f467e30c.svg";